<template>
  <div class="action-box">
    <div class="main">
      <div class="active" @click="showAction">
        {{showItem.name}}
        <Icon name="arrow-down" />
      </div>
      <div class="btn-add" @click="toAdd">
        添加
      </div>
      <div class="message" :class="{'hideBadge': messageTotal <= 0}" @click="handMessage">
        <Badge :content="messageTotal" max="99">
            <Icon name="comment-o" :size="24" />
        </Badge>
      </div>
    </div>
    <ActionSheet
      v-model="actionShow"
      :actions="actions"
      :close-on-click-action="true"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { ActionSheet, Icon, Badge } from "vant";
export default {
  components: {
    ActionSheet,
    Icon,
    Badge
  },
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    active: {
      type: [String, Number],
      default: ""
    },
    messageTotal: {
      type: Number,
      default: 0
    }
  },
  computed: {
    showItem(){
      const _find = this.listData.find(item => item.value == this.active);
      return _find || this.listData[0] || {};
    },
    actions(){
      return this.listData.map(item => {
        return {
          className: item.value == this.active ? "active" : "",
          ...item
        }
      })
    }
  },
  data(){
    return {
      actionShow: false,
    }
  },
  methods: {
    showAction(){
      this.actionShow = !this.actionShow;
    },
    onSelect(action, index){
      this.$emit("select", { action, index });
    },
    toAdd(){
      this.$router.push({
        path: "/h5-create-strategy",
        query: {
          strategyId: this.active
        }
      })
    },
    // 跳转到异常信息列表
    handMessage(){
      this.$router.push({
        path: "/h5-exception-message"
      })
    }
  }
};
</script>

<style scoped lang="less">
  .action-box{
    overflow: hidden;
    background: #fff;
    height: 80px;
    display: flex;
    align-items: center;
    .main{
      flex: 1;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 32px;
      line-height: 40px;
      .active{
        color: #1C0955;
        flex: 1;
      }
      .btn-add{
        color: #1C0955;
        border: #1C0955 solid 1px;
        border-radius: 10px;
        padding: 10px 30px;
        line-height: 1;
      }
      .message{
        margin-top: 10px;
        line-height: 1;
        margin-left: 30px;
        &.hideBadge {
          /deep/ .van-badge {
            display: none !important;
          }
        }
      }
    }
    /deep/ .van-action-sheet__item{
      border-bottom: #eee solid 1px;
      color: #323233;
      &.active{
        font-weight: bold;
      }
    }
  }
</style>
